/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { message, Select, Card, Tag, Space, Button, InputNumber } from "antd";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { tripsApi, boatApi } from "../../apis";

const { Option } = Select;

const AddTrip = () => {
  const history = useHistory();
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [decks, setDecks] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    startTime: "09:00",
    endTime: "11:00",
  });
  const [deckPricing, setDeckPricing] = useState([]);

  // Get today's date in YYYY-MM-DD format for min date attribute
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    boatApi
      .getAllDecks()
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        setDecks(arr);
        setDeckPricing(
          arr.map((d) => ({
            deckId: d.id,
            adultPrice: d.defaultAdultPrice,
            childPrice: d.defaultChildPrice,
            capacity: d.capacity,
          })),
        );
      })
      .catch(() => message.error("Failed to load decks"));
  }, []);

  const handleChange = (e) =>
    setFormData((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleDeckPriceChange = (deckId, field, value) => {
    setDeckPricing((prev) =>
      prev.map((dp) => (dp.deckId === deckId ? { ...dp, [field]: value } : dp)),
    );
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setFormData((f) => ({ ...f, startDate: newStartDate }));

    // If end date is before the new start date, clear or update end date
    if (formData.endDate && formData.endDate < newStartDate) {
      setFormData((f) => ({ ...f, endDate: "" }));
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setFormData((f) => ({ ...f, endDate: newEndDate }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return message.error("Trip name is required");
    if (!formData.startDate || !formData.endDate)
      return message.error("Start and end dates are required");

    const today = getTodayDate();
    if (formData.startDate < today)
      return message.error("Start date cannot be in the past");
    if (formData.endDate < today)
      return message.error("End date cannot be in the past");
    if (formData.endDate < formData.startDate)
      return message.error("End date must be after start date");

    try {
      setLoading(true);
      await tripsApi.create({ ...formData, deckPricing });
      message.success(
        "Trip created successfully! Daily schedules have been generated.",
      );
      history.push("/trips");
    } catch (e) {
      const msg = e.response?.data?.message;
      if (Array.isArray(msg)) msg.forEach((m) => message.error(m));
      else message.error(msg || "Failed to create trip");
    } finally {
      setLoading(false);
    }
  };

  const todayDate = getTodayDate();

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Add New Trip</h5>
                  <button
                    type="button"
                    className="btn btn-primary cancel me-2"
                    onClick={() => history.goBack()}
                    disabled={loading}
                  >
                    Back
                  </button>
                </div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group-item">
                  <h5 className="form-title">Trip Details</h5>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Trip Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          placeholder="e.g. Sunset Cruise"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input-block mb-3">
                        <label>Description</label>
                        <input
                          className="form-control"
                          placeholder="Short description"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Start Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="startDate"
                          value={formData.startDate}
                          onChange={handleStartDateChange}
                          min={todayDate}
                          required
                          disabled={loading}
                        />
                        <small className="text-muted d-block mt-1">
                          Cannot select dates before {todayDate}
                        </small>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          End Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={formData.endDate}
                          onChange={handleEndDateChange}
                          min={formData.startDate || todayDate}
                          required
                          disabled={loading}
                        />
                        <small className="text-muted d-block mt-1">
                          Must be on or after {formData.startDate || todayDate}
                        </small>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          Start Time <span className="text-danger">*</span>
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          name="startTime"
                          value={formData.startTime}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="input-block mb-3">
                        <label>
                          End Time <span className="text-danger">*</span>
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          name="endTime"
                          value={formData.endTime}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {decks.length > 0 && (
                  <div className="form-group-item mt-3">
                    <h5 className="form-title">
                      Deck Pricing (overrides defaults for this trip)
                    </h5>
                    <div className="row">
                      {deckPricing.map((dp) => {
                        const deck = decks.find((d) => d.id === dp.deckId);
                        return (
                          <div key={dp.deckId} className="col-lg-4 col-md-6">
                            <Card
                              size="small"
                              title={deck?.name}
                              style={{ marginBottom: 12, borderRadius: 8 }}
                            >
                              <div className="mb-2">
                                <label
                                  style={{ fontSize: 12, fontWeight: 600 }}
                                >
                                  Adult Price (EGP)
                                </label>
                                <InputNumber
                                  style={{ width: "100%" }}
                                  min={1}
                                  value={dp.adultPrice}
                                  onChange={(v) =>
                                    handleDeckPriceChange(dp.deckId, "adultPrice", v)
                                  }
                                  disabled={loading}
                                />
                              </div>
                              <div className="mb-2">
                                <label
                                  style={{ fontSize: 12, fontWeight: 600 }}
                                >
                                  Child Price (EGP)
                                </label>
                                <InputNumber
                                  style={{ width: "100%" }}
                                  min={1}
                                  value={dp.childPrice}
                                  onChange={(v) =>
                                    handleDeckPriceChange(dp.deckId, "childPrice", v)
                                  }
                                  disabled={loading}
                                />
                              </div>
                              <div>
                                <label
                                  style={{ fontSize: 12, fontWeight: 600 }}
                                >
                                  Capacity (seats)
                                </label>
                                <InputNumber
                                  style={{ width: "100%" }}
                                  min={1}
                                  value={dp.capacity}
                                  onChange={(v) =>
                                    handleDeckPriceChange(
                                      dp.deckId,
                                      "capacity",
                                      v,
                                    )
                                  }
                                  disabled={loading}
                                />
                              </div>
                            </Card>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className="form-group-item border-0">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-primary cancel me-2"
                          onClick={() => history.goBack()}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" />
                              Creating…
                            </>
                          ) : (
                            "Create Trip"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTrip;
